import { cn } from '../../utils/cn';

export type BadgeVariant =
  | 'default'
  | 'success'
  | 'warning'
  | 'error'
  | 'info'
  | 'outline'
  | 'secondary';

export type BadgeSize = 'sm' | 'md' | 'lg';

export interface BadgeProps {
  variant?: BadgeVariant;
  size?: BadgeSize;
  children: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  size = 'md',
  children,
  className,
}) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full';

  const variantClasses = {
    default: 'bg-[var(--color-primary-100)] text-[var(--color-primary-800)]',
    success: 'bg-[var(--color-success-100)] text-[var(--color-success-800)]',
    warning: 'bg-[var(--color-warning-100)] text-[var(--color-warning-800)]',
    error: 'bg-[var(--color-error-100)] text-[var(--color-error-800)]',
    info: 'bg-[var(--color-info-100)] text-[var(--color-info-800)]',
    outline: 'border border-[var(--color-border-medium)] text-[var(--color-text-primary)]',
    secondary: 'bg-[var(--color-neutral-100)] text-[var(--color-text-primary)]',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  return (
    <span className={cn(baseClasses, variantClasses[variant], sizeClasses[size], className)}>
      {children}
    </span>
  );
};


